import { render, staticRenderFns } from "./HowWork.vue?vue&type=template&id=16360955"
import script from "./HowWork.vue?vue&type=script&lang=js"
export * from "./HowWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports